import styled from "styled-components/macro";

export const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 800px;
  margin: 0 auto;

  @media screen and (max-width: 480px) {
    flex-direction: column;
    height: 100%;
  }
`;

export const TabMenu = styled.div`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;
`;
export const TabItem = styled.div`
  height: 80px;
`;

export const TabLinks = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  border-bottom: ${({ active }) => (active ? "3px solid #000" : undefined)};

  @media screen and (max-width: 480px) {
    border-left: ${({ active }) => (active ? "5px solid #000" : undefined)};

    border-bottom: none;
  }
`;
